import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./question.css";
import { Formik, Form, ErrorMessage } from "formik";
import { questionValidation } from "../../../validations/AdminValidations";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FormikControl from "../../../common/Formik/FormikControl";
import { makeStyles } from "@material-ui/core/styles";

import {
  curriculumListFun,
  subjectListFun,
  topicListFun,
  chapterListFun,
} from "../../../utils/utils";
import "../../../common/Formik/Common.css";
import Autocomplete1 from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import TextError from "../../../common/Formik/TextError";
import { Link } from "react-router-dom";
const useStyles = makeStyles({
  auto: {
    width: "85%",
    position: "absolute",
  },
});
const AddQuestion = (props) => {
  const classes = useStyles();
  const {
    mode,
    questionValues,
    curriculumList,
    subjectsList,
    topicsList,
    chaptersList,
    handleInput,
    handleSubmit,
    handleQuestionName,
    questionError,
    handleInput1,
    handleFileChange,
  } = props;

  const data = questionValues;
  let curriculumOptions = curriculumListFun(curriculumList);
  let subjectOptions = subjectListFun(subjectsList);
  let topicOptions = topicListFun(topicsList);
  let chapterOptions = chapterListFun(chaptersList);

  console.log("data//", chapterOptions);

  const [ans1, setAns1] = useState("");
  const [ans2, setAns2] = useState("");
  const [ans3, setAns3] = useState("");
  const [ans4, setAns4] = useState("");

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
              width: "96%",
              alignItems: "center",
            }}
          >
            <h1
              className="form-heading"
              style={{ color: "#4A1D75", fontFamily: "roboto" }}
            >
              {mode} Question Library
            </h1>
            <div
            //  className="add-btn-div"
            >
              <Link
                to={`/admin/question`}
                className="btn btn-sm "
                style={{
                  borderRadius: "40px",
                  backgroundColor: "#4A1D75",
                  border: "2px solid #4A1D75",
                  width: "140px",
                  textAlign: "center",
                  padding: "6px",
                  color: "white",
                  height: "auto",
                }}
              >
                Cancel
              </Link>
            </div>
          </div>
          <div className="card  mb-3">
            <div className="card-body">
              <Formik
                initialValues={data}
                validationSchema={questionValidation}
                validateOnMount
                enableReinitialize
              >
                {(formik) => {
                  //console.log("formik", formik);
                  const { handleChange } = formik;
                  return (
                    <Form>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label
                              className="label-heading"
                              htmlFor="curriculum"
                            >
                              curriculums
                            </label>

                            {mode === "Add" && (
                              <Autocomplete1
                                disablePortal
                                id="combo-box-demo"
                                // className="form-control"
                                options={curriculumOptions}
                                getOptionLabel={(option) => option.curriculum}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "curriculum");
                                    return;
                                  }
                                  handleInput1(value.curriculum, "curriculum");
                                }}
                                disableClearable={true}
                                style={{ width: "100%", height: "38px" }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            {mode === "Edit" && data.curriculum && (
                              <Autocomplete1
                                disablePortal
                                id="combo-box-demo"
                                options={curriculumOptions}
                                getOptionLabel={(option) => option.curriculum}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "curriculum");
                                    return;
                                  }
                                  handleInput1(value.curriculum, "curriculum");
                                }}
                                disableClearable={true}
                                defaultValue={{
                                  curriculum: data.curriculum
                                    ? data.curriculum
                                    : "",
                                }}
                                style={{
                                  width: "100%",
                                  height: "38px",
                                  /*  overflow: "hidden", */
                                  position: "initial",
                                  top: "0",
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            <ErrorMessage
                              component={TextError}
                              name="curriculum"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group ">
                            <label
                              className="label-heading"
                              htmlFor="curriculum"
                            >
                              subject
                            </label>

                            {mode === "Add" && (
                              <Autocomplete1
                                disablePortal
                                id="combo-box-demo"
                                options={subjectOptions}
                                getOptionLabel={(option) => option.subject}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "subject");
                                    return;
                                  }
                                  handleInput1(value.subject, "subject");
                                }}
                                style={{ width: "100%", height: "38px" }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            {mode === "Edit" && (
                              <Autocomplete1
                                disablePortal
                                id="combo-box-demo"
                                options={subjectOptions}
                                getOptionLabel={(option) => option.subject}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "subject");
                                    return;
                                  }
                                  handleInput1(value.subject, "subject");
                                }}
                                disableClearable={true}
                                value={{
                                  subject: data.subject ? data.subject : "",
                                }}
                                style={{
                                  width: "100%",
                                  height: "38px",
                                  /*  overflow: "hidden", */
                                  position: "initial",
                                  top: "0",
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            <ErrorMessage
                              component={TextError}
                              name="subject"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group ">
                            <label
                              className="label-heading"
                              htmlFor="curriculum"
                            >
                              topic
                            </label>

                            {mode === "Add" && (
                              <Autocomplete1
                                disablePortal
                                id="combo-box-demo"
                                options={topicOptions}
                                getOptionLabel={(option) => option.topic}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "topic");
                                    return;
                                  }
                                  handleInput1(value.topic, "topic");
                                }}
                                style={{ width: "100%", height: "38px" }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            {mode === "Edit" && (
                              <Autocomplete1
                                disablePortal
                                id="combo-box-demo"
                                options={topicOptions}
                                getOptionLabel={(option) => option.topic}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "topic");
                                    return;
                                  }
                                  handleInput1(value.topic, "topic");
                                }}
                                disableClearable={true}
                                value={{
                                  topic: data.topic ? data.topic : "",
                                }}
                                style={{
                                  width: "100%",
                                  height: "38px",
                                  /* overflow: "hidden", */
                                  position: "initial",
                                  top: "0",
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            <ErrorMessage component={TextError} name="topic" />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group ">
                            <label
                              className="label-heading"
                              htmlFor="curriculum"
                            >
                              chapter
                            </label>

                            {mode === "Add" && (
                              <Autocomplete1
                                disablePortal
                                id="combo-box-demo"
                                options={chapterOptions}
                                getOptionLabel={(option) => option.chapter}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "chapter");
                                    return;
                                  }

                                  handleInput1(value.chapter, "chapter");
                                }}
                                style={{ width: "100%", height: "38px" }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            {mode === "Edit" && (
                              <Autocomplete1
                                style={{ width: "100%", position: "initial" }}
                                disablePortal
                                id="combo-box-demo"
                                options={chapterOptions}
                                getOptionLabel={(option) => option.chapter}
                                onChange={(event, value) => {
                                  if (value === null) {
                                    handleInput1("", "chapter");
                                    return;
                                  }

                                  handleInput1(value.chapter, "chapter");
                                }}
                                className={classes.auto}
                                disableClearable={true}
                                value={{
                                  chapter: data.chapter ? data.chapter : "",
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                            )}
                            <ErrorMessage
                              component={TextError}
                              name="chapter"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="relative">
                            <FormikControl
                              control="select"
                              label="Question Type"
                              name="questionType"
                              options={[
                                { _id: "1", name: "Text" },
                                { _id: "2", name: "Multi" },
                              ]}
                              value={data.questionType}
                              onChange={(e) => {
                                handleChange(e);
                                handleInput(e);
                              }}
                            />
                            <KeyboardArrowDownIcon className="drop_icon" />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <FormikControl
                            control="input"
                            type="text"
                            name="questionmarks"
                            label="Marks for Question"
                            onChange={(e) => {
                              handleChange(e);
                              handleInput(e);
                            }}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Question</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={data.question ? data.question : ""}
                            onChange={(event, editor) => {
                              handleQuestionName(editor.getData());
                            }}
                          />
                          {questionError && (
                            <div className="error">Required</div>
                          )}
                        </div>
                        {console.log(ans1)}
                        {data.questionType === "Multi" && (
                          <React.Fragment>
                            <div className="col-md-6">
                              <FormikControl
                                control="input"
                                type="text"
                                label="Correct Answer"
                                name="correctanswer"
                                onChange={(e) => {
                                  handleChange(e);
                                  handleInput(e);
                                }}
                              />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  handleFileChange(e);
                                  setAns1(
                                    URL.createObjectURL(e.target.files[0])
                                  );
                                }}
                              ></input>
                              <br />
                              <br />
                              <img
                                src={
                                  // data.image_correctanswer
                                  //   ? data.image_correctanswer.location
                                  //   : ans1
                                  ans1.length !== 0
                                    ? ans1
                                    : data.image_correctanswer.location
                                }
                                alt="Placeholder"
                                className="w-100"
                              />
                              <br />
                              <br />
                            </div>

                            <div className="col-md-6">
                              <FormikControl
                                control="input"
                                type="text"
                                name="answer1"
                                label="Wrong Answer 1"
                                onChange={(e) => {
                                  handleChange(e);
                                  handleInput(e);
                                }}
                              />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  handleFileChange(e);
                                  setAns2(
                                    URL.createObjectURL(e.target.files[0]),
                                    console.log(
                                      URL.createObjectURL(e.target.files[0])
                                    )
                                  );
                                }}
                              ></input>
                              <br />
                              <br />
                              <img
                                src={
                                  // data.image_answer1
                                  //   ? data.image_answer1.location
                                  //   : ans2
                                  ans2.length !== 0
                                    ? ans2
                                    : data.image_answer1.location
                                }
                                alt="Placeholder"
                                className="w-100"
                              />
                              <br />
                              <br />
                            </div>

                            <div className="col-md-6">
                              <FormikControl
                                control="input"
                                type="text"
                                name="answer2"
                                label="Wrong Answer 2"
                                onChange={(e) => {
                                  handleChange(e);
                                  handleInput(e);
                                }}
                              />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  handleFileChange(e);
                                  setAns3(
                                    URL.createObjectURL(e.target.files[0])
                                  );
                                }}
                              ></input>
                              <br />
                              <br />
                              <img
                                src={
                                  // data.image_answer3
                                  //   ? data.image_answer3.location
                                  //   : ans3
                                  ans3.length !== 0
                                    ? ans3
                                    : data.image_answer2.location
                                }
                                alt="Placeholder"
                                className="w-100"
                              />
                              <br />
                              <br />
                            </div>

                            <div className="col-md-6">
                              <FormikControl
                                control="input"
                                type="text"
                                name="answer3"
                                label="Wrong Answer 3"
                                onChange={(e) => {
                                  handleChange(e);
                                  handleInput(e);
                                }}
                              />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  handleFileChange(e);
                                  setAns4(
                                    URL.createObjectURL(e.target.files[0])
                                  );
                                }}
                              ></input>
                              <br />
                              <br />
                              <img
                                src={
                                  // data.image_answer3
                                  //   ? data.image_answer3.location
                                  //   : ans4
                                  ans4.length !== 0
                                    ? ans4
                                    : data.image_answer3.location
                                }
                                alt="Placeholder"
                                className="w-100"
                              />
                              <br />
                              <br />
                            </div>
                          </React.Fragment>
                        )}

                        <div className="text-center col-md-12">
                          <button
                            // type="submit"
                            className="btn btn-sm  mt-4"
                            onClick={() => handleSubmit(formik)}
                            style={{
                              borderRadius: "40px",
                              backgroundColor: "#4A1D75",
                              border: "2px solid #4A1D75",
                              width: "140px",
                              textAlign: "center",
                              padding: "6px",
                              color: "white",
                              height: "auto",
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddQuestion;
